module.exports = __webpack_public_path__ + "img/dubai-v.15b9933b.png";